import React from 'react';
import PropTypes from 'prop-types';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import LockIcon from '@material-ui/icons/Lock';
import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

function MainMenu({ classes, open, languagesFlag, menuItems, anchorEl, handleClose, global, handleSelectLanguage }) {
  return (
    <>
      <Menu
        classes={{ paper: classes.paper, list: classes.list }}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={open}
        onClose={handleClose}
      >
        {_.map(menuItems, (item, index) => {
          if (item.link === '/profile' && !global.user.data) return false;
          return (
            <div key={index} className={classes.itemsBox}>
              <MenuItem
                onClick={item.items ? null : handleClose}
                classes={{ root: classes.root, gutters: classes.gutters }}
              >
                {/* If link is private and user not sign in -> render button */}
                {item.link && !(!!item.private && !global.user.data) ? (
                  <Link to={item.link} className={classes.link} />
                ) : (
                  <button type="button" className={classes.linkBtn} onClick={() => item.func()} />
                )}
                <ListItemIcon
                  classes={{
                    root: item.label === 'Languages' && languagesFlag ? classes.iconRootActive : classes.iconRoot,
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <span>{item.label}</span>
                {/* If link is private and user not sign in -> render lock icon */}
                {!!item.private && !global.user.data ? <LockIcon className={classes.lockIcon} /> : null}
              </MenuItem>
              {item.items && (
                <Collapse in={languagesFlag} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {_.map(item.items, (language, ind) => (
                      <ListItem
                        button
                        key={`language_${ind}`}
                        classes={{ root: classes.languageRoot }}
                        onClick={() => {
                          handleClose();
                          handleSelectLanguage(language);
                        }}
                      >
                        <ListItemText>{language}</ListItemText>
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              )}
            </div>
          );
        })}
      </Menu>
    </>
  );
}

MainMenu.propTypes = {
  classes: PropTypes.object,
  global: PropTypes.object,
  anchorEl: PropTypes.any,
  open: PropTypes.bool,
  languagesFlag: PropTypes.bool,
  menuItems: PropTypes.array,
  handleClose: PropTypes.func,
  handleSelectLanguage: PropTypes.func,
};

export default MainMenu;
